import { Controller } from '@hotwired/stimulus';

export default class ScrollIntoViewController extends Controller {
  static values = {
    arguments: Array
  }

  connect() {
    this.data.element.scrollIntoView(...this.argumentsValue);
  }
}
